// @ts-check
import React from "react"
import PropTypes from "prop-types"
import { VACATION_STATES } from "../../../consts/modules/vacations.consts"
import VacationStatusChip from "../../../components/molecules/VacationStatusChip.molecule"
import { Ripple } from "primereact/ripple"
import {
  getVacationRangeLabel,
  getVacationState,
  getVacationTooltip,
} from "../../../utils/vacation.utils"
import { Skeleton } from "../../../components/atoms/misc/Skeleton.atom"
import VacationDayTypesBreakdown from "./VacationDayTypesBreakdown.molecule"
import { clsx } from "../../../utils/strings.utils"
import UserChip, {
  USER_CHIP_SIZES,
  USER_CHIP_TYPES,
} from "../../../components/molecules/UserChip.molecule"

/** @type {import("./VacationRequestCard.compound.types")["VacationRequestCard"]} */
const VacationRequestCard = ({
  onClick = () => {},
  onContextMenu,
  onShowOnlyThisVacation,
  vacationRequest,
  teamMember,
  mode = "admin",
  loading = false,
  isFilteringOnlyThisVacation = false,
}) => {
  const vacationState = getVacationState(vacationRequest)
  if (loading) {
    return <VacationRequestCardSkeleton />
  }

  return (
    <div
      className={`request-card p-ripple ${vacationState === VACATION_STATES.BLOCKED ? "p-disabled" : ""}`}
      onClick={(e) => {
        if (vacationState !== VACATION_STATES.BLOCKED) {
          onClick(vacationRequest)
        }
      }}
      onContextMenu={(e) => {
        if (onContextMenu) {
          e.preventDefault()
          onContextMenu(e, vacationRequest)
        }
      }}
    >
      <div className="flex justify-content-between align-items-center">
        {mode === "admin" && (
          <div className="flex gap-1">
            <UserChip
              user={teamMember}
              variant={USER_CHIP_TYPES.CUSTOM}
              size={USER_CHIP_SIZES.NORMAL}
              useTooltip
              tooltipConfig={{
                "data-pr-position": "bottom",
              }}
            />
            {teamMember?.fullName}
          </div>
        )}
        {mode === "team-member" && vacationRequest?.vacationsMotive}
        <div className="flex gap-1">
          {onShowOnlyThisVacation && (
            <button
              onClick={(e) => {
                e.stopPropagation()
                onShowOnlyThisVacation(vacationRequest)
              }}
              className={clsx(
                "show-specific-vacation-button justify-content-center align-items-center p-1 border-radius-lg border-1",
                isFilteringOnlyThisVacation && "active"
              )}
            >
              <i
                className={clsx(
                  "pi",
                  isFilteringOnlyThisVacation ? "pi-calendar-times" : (
                    "pi-calendar"
                  )
                )}
              ></i>
            </button>
          )}
          <VacationStatusChip
            status={vacationState}
            variant="short"
            tooltipContent={{
              title: getVacationTooltip(vacationRequest),
            }}
            showTooltip={
              vacationState !== VACATION_STATES.PENDING ||
              !!getVacationTooltip(vacationRequest)
            }
          />
        </div>
      </div>
      <div className="flex gap-1">
        <i className="pi pi-calendar"></i>
        <span>
          {getVacationRangeLabel(
            vacationRequest?.numberOfVacationDays,
            vacationRequest?.startDate,
            vacationRequest?.endDate
          )}
        </span>
      </div>
      <VacationDayTypesBreakdown vacationRequest={vacationRequest} />
      <Ripple />
    </div>
  )
}

export default VacationRequestCard

// @ts-ignore
VacationRequestCard.propTypes = {
  onClick: PropTypes.func,
  vacationRequest: PropTypes.shape({
    numberOfVacationDays: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    numberOfBucketDays: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    numberOfPlusDays: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    numberOfAdditionalDays: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    changeRequest: PropTypes.bool,
    plusDaysPayedOff: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    vacationsHaveBeenCounted: PropTypes.number,
  }),
  teamMember: PropTypes.shape({
    fullName: PropTypes.string,
    idHolidaySchema: PropTypes.number,
  }),
  props: PropTypes.object,
  mode: PropTypes.string,
}

export const VacationRequestCardSkeleton = () => {
  return (
    <div className={`request-card p-ripple skeleton`}>
      <div
        className="flex justify-content-between align-items-center"
        style={{ height: "20px" }}
      >
        <div className="flex gap-1">
          <i className="pi pi-user"></i>
          <Skeleton />
        </div>
        <Skeleton height={"20px"} />
      </div>
      <div className="flex gap-1">
        <i className="pi pi-calendar"></i>
        <Skeleton height={"20px"} />
      </div>
      <Skeleton height={"21px"} />
    </div>
  )
}
